"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}

/**
 * Calculate the offset between the mouse-press point and current one
 * Adding the bias parameter to reduce the sensitivity of mouse moving detection
 *
 * @public
 * @param {Point} origOffset - The location on mouse pressed
 * @param {Point} currOffset - The location of the current mouse
 * @param {number} bias - The value to determine whether the mouse is moving
 */
function isMouseMoving(origOffset, currOffset) {
  var bias = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var isMoving = false;
  if (!origOffset || !currOffset) {
    return isMoving;
  }
  if (origOffset.hasOwnProperty('x') && currOffset.hasOwnProperty('x')) {
    isMoving = Math.abs(origOffset.x - currOffset.x) > bias;
  }
  if (!isMoving && origOffset.hasOwnProperty('y') && currOffset.hasOwnProperty('y')) {
    isMoving = Math.abs(origOffset.y - currOffset.y) > bias;
  }
  return isMoving;
}
var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
  if (!el) {
    return null;
  }
  var _el$getBoundingClient = el.getBoundingClientRect(),
    top = _el$getBoundingClient.top,
    left = _el$getBoundingClient.left;
  return {
    x: left,
    y: top
  };
}
function isRightClick(e) {
  if ('which' in e) {
    return e.which === 3;
  } else if ('button' in e) {
    return e.button === 2;
  }
  return false;
}
var MouseBackend = /*#__PURE__*/function () {
  function MouseBackend(manager, context, options) {
    (0, _classCallCheck2["default"])(this, MouseBackend);
    this.ctx = context;
    this.options = options;
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.sourceNodes = {};
    this.sourceNodesOptions = {};
    this.sourcePreviewNodes = {};
    this.sourcePreviewNodesOptions = {};
    this.targetNodes = {};
    this.targetNodeOptions = {};
    this.mouseClientOffset = {};
    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
    this.handleWindowMoveStart = this.handleWindowMoveStart.bind(this);
    this.handleWindowMoveStartCapture = this.handleWindowMoveStartCapture.bind(this);
    this.handleWindowMoveCapture = this.handleWindowMoveCapture.bind(this);
    this.handleWindowMoveEndCapture = this.handleWindowMoveEndCapture.bind(this);
  }
  return (0, _createClass2["default"])(MouseBackend, [{
    key: "setup",
    value: function setup() {
      if (typeof this.ctx === 'undefined') {
        return;
      }
      if (this.constructor.isSetUp) {
        throw new Error('Cannot have two DnD Mouse backend at the same time');
      }
      this.constructor.isSetUp = true;
      this.ctx.addEventListener('mousedown', this.handleWindowMoveStartCapture, true);
      this.ctx.addEventListener('mousedown', this.handleWindowMoveStart);
      this.ctx.addEventListener('mousemove', this.handleWindowMoveCapture, true);
      this.ctx.addEventListener('mouseup', this.handleWindowMoveEndCapture, true);
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset(sourceId) {
      return getNodeClientOffset(this.sourceNodes[sourceId]);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      if (typeof this.ctx === 'undefined') {
        return;
      }
      this.constructor.isSetUp = false;
      this.mouseClientOffset = {};
      this.ctx.removeEventListener('mousedown', this.handleWindowMoveStartCapture, true);
      this.ctx.removeEventListener('mousedown', this.handleWindowMoveStart);
      this.ctx.removeEventListener('mousemove', this.handleWindowMoveCapture, true);
      this.ctx.removeEventListener('mouseup', this.handleWindowMoveEndCapture, true);
    }
  }, {
    key: "connectDragSource",
    value: function connectDragSource(sourceId, node) {
      var _this = this;
      this.sourceNodes[sourceId] = node;
      var handleMoveStart = this.handleMoveStart.bind(this, sourceId);
      node.addEventListener('mousedown', handleMoveStart);
      return function () {
        delete _this.sourceNodes[sourceId];
        node.removeEventListener('mousedown', handleMoveStart);
      };
    }
  }, {
    key: "connectDragPreview",
    value: function connectDragPreview(sourceId, node, options) {
      var _this2 = this;
      this.sourcePreviewNodesOptions[sourceId] = options;
      this.sourcePreviewNodes[sourceId] = node;
      return function () {
        delete _this2.sourcePreviewNodes[sourceId];
        delete _this2.sourcePreviewNodesOptions[sourceId];
      };
    }
  }, {
    key: "connectDropTarget",
    value: function connectDropTarget(targetId, node) {
      var _this3 = this;
      this.targetNodes[targetId] = node;
      return function () {
        delete _this3.targetNodes[targetId];
      };
    }
  }, {
    key: "handleWindowMoveStartCapture",
    value: function handleWindowMoveStartCapture() {
      this.moveStartSourceIds = [];
    }
  }, {
    key: "handleMoveStart",
    value: function handleMoveStart(sourceId, e) {
      // Ignore right mouse button.
      if (isRightClick(e)) return;
      this.moveStartSourceIds.unshift(sourceId);
    }
  }, {
    key: "handleWindowMoveStart",
    value: function handleWindowMoveStart(e) {
      var clientOffset = getEventClientOffset(e);
      if (clientOffset) {
        this.mouseClientOffset = clientOffset;
      }
    }
  }, {
    key: "handleWindowMoveCapture",
    value: function handleWindowMoveCapture(e) {
      var _this4 = this;
      var moveStartSourceIds = this.moveStartSourceIds;
      var clientOffset = getEventClientOffset(e);
      if (!clientOffset) return;
      if (!this.monitor.isDragging() && moveStartSourceIds && isMouseMoving(this.mouseClientOffset, clientOffset, this.options.offsetBias)) {
        this.moveStartSourceIds = null;
        this.actions.beginDrag(moveStartSourceIds, {
          clientOffset: this.mouseClientOffset,
          getSourceClientOffset: this.getSourceClientOffset,
          publishSource: false
        });
      }
      if (!this.monitor.isDragging()) {
        return;
      }
      var sourceNode = this.sourceNodes[this.monitor.getSourceId()];
      this.installSourceNodeRemovalObserver(sourceNode);
      this.actions.publishDragSource();
      e.preventDefault();
      var matchingTargetIds = Object.keys(this.targetNodes).filter(function (targetId) {
        var boundingRect = _this4.targetNodes[targetId].getBoundingClientRect();
        return clientOffset.x >= boundingRect.left && clientOffset.x <= boundingRect.right && clientOffset.y >= boundingRect.top && clientOffset.y <= boundingRect.bottom;
      });
      this.actions.hover(matchingTargetIds, {
        clientOffset: clientOffset
      });
    }
  }, {
    key: "handleWindowMoveEndCapture",
    value: function handleWindowMoveEndCapture(e) {
      this.mouseClientOffset = {};
      if (!this.monitor.isDragging() || this.monitor.didDrop()) {
        this.moveStartSourceIds = null;
        return;
      }
      e.preventDefault();
      this.uninstallSourceNodeRemovalObserver();
      this.actions.drop();
      this.actions.endDrag();
    }
  }, {
    key: "installSourceNodeRemovalObserver",
    value: function installSourceNodeRemovalObserver(node) {
      var _this5 = this;
      this.uninstallSourceNodeRemovalObserver();
      this.draggedSourceNode = node;
      this.draggedSourceNodeRemovalObserver = new this.ctx.MutationObserver(function () {
        if (!node.parentElement) {
          _this5.resurrectSourceNode();
          _this5.uninstallSourceNodeRemovalObserver();
        }
      });
      if (!node || !node.parentElement) {
        return;
      }
      this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
        childList: true
      });
    }
  }, {
    key: "resurrectSourceNode",
    value: function resurrectSourceNode() {
      this.draggedSourceNode.style.display = 'none';
      this.draggedSourceNode.removeAttribute('data-reactid');
      document.body.appendChild(this.draggedSourceNode);
    }
  }, {
    key: "uninstallSourceNodeRemovalObserver",
    value: function uninstallSourceNodeRemovalObserver() {
      if (this.draggedSourceNodeRemovalObserver) {
        this.draggedSourceNodeRemovalObserver.disconnect();
      }
      this.draggedSourceNodeRemovalObserver = null;
      this.draggedSourceNode = null;
    }
  }]);
}();
var _default = exports["default"] = function _default(manager, context) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new MouseBackend(manager, context, options);
};
//# sourceMappingURL=index.js.map